import { useIsMobile } from '../../../../../hooks/useIsMobile'

export default function useIsMobileControlSelect(config) {
    const isMobile = useIsMobile()
    const { ForControl, Type, TableConfig } = config

    return isMobile && ForControl && Type === 'Table' && TableConfig.Fields.length === 1
}
